/* tslint:disable */
/* eslint-disable */
/**
 * Portfolio Management API
 * REST API for portfolio management service.
 *
 * The version of the OpenAPI document: 1.0
 * Contact: info@etractive.de
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PortfolioStatistic
 */
export interface PortfolioStatistic {
    /**
     * 
     * @type {PortfolioStatisticStatusEnum}
     * @memberof PortfolioStatistic
     */
    status: PortfolioStatisticStatusEnum;
    /**
     * 
     * @type {number}
     * @memberof PortfolioStatistic
     */
    count: number;
}


/**
 * @export
 */
export const PortfolioStatisticStatusEnum = {
    Open: 'Open',
    InLocalReview: 'InLocalReview',
    InGlobalReview: 'InGlobalReview',
    Approved: 'Approved'
} as const;
export type PortfolioStatisticStatusEnum = typeof PortfolioStatisticStatusEnum[keyof typeof PortfolioStatisticStatusEnum];


/**
 * Check if a given object implements the PortfolioStatistic interface.
 */
export function instanceOfPortfolioStatistic(value: object): value is PortfolioStatistic {
    if (!('status' in value) || value['status'] === undefined) return false;
    if (!('count' in value) || value['count'] === undefined) return false;
    return true;
}

export function PortfolioStatisticFromJSON(json: any): PortfolioStatistic {
    return PortfolioStatisticFromJSONTyped(json, false);
}

export function PortfolioStatisticFromJSONTyped(json: any, ignoreDiscriminator: boolean): PortfolioStatistic {
    if (json == null) {
        return json;
    }
    return {
        
        'status': json['status'],
        'count': json['count'],
    };
}

export function PortfolioStatisticToJSON(json: any): PortfolioStatistic {
    return PortfolioStatisticToJSONTyped(json, false);
}

export function PortfolioStatisticToJSONTyped(value?: PortfolioStatistic | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'status': value['status'],
        'count': value['count'],
    };
}

